module.exports = __webpack_public_path__ + "static/media/SPRINGTER _VIDEO_FOTOS_SIN TEXTOS_1280x720_FINAL.d8a15db.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/SPRINGTER _VIDEO_FOTOS_SIN TEXTOS_1280x720_FINAL.mp4
// module id = ZMj6
// module chunks = 1